import React from 'react'
import {
  BsChevronRight,
  BsClock,
  BsListCheck,
  BsPerson,
} from 'react-icons/bs'
import { MdCheckCircleOutline, MdRefresh } from 'react-icons/md'
import { getIncompleteSubtaskCount } from './taskUtils'

const formatDueTime = (value) => {
  const dueDate = new Date(value)
  if (Number.isNaN(dueDate.getTime())) return ''
  return dueDate.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
  })
}

const TodayTasks = ({ tasks, loading, error, onRetry, onTaskClick }) => {
  const dateLabel = new Date().toLocaleDateString(undefined, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  })

  return (
    <div className='atharo-hub__tasks-screen'>
      <section className='atharo-hub__tasks-summary'>
        <span>Due today</span>
        <strong>{tasks.length}</strong>
        <p>{dateLabel}</p>
      </section>

      {loading && (
        <div className='atharo-hub__tasks-state' role='status'>
          <span className='atharo-hub__tasks-loader' aria-hidden='true' />
          Loading today&apos;s tasks…
        </div>
      )}

      {!loading && error && (
        <div className='atharo-hub__tasks-state atharo-hub__tasks-state--error' role='alert'>
          <strong>Tasks could not be loaded.</strong>
          <span>{error}</span>
          <button type='button' onClick={onRetry}><MdRefresh aria-hidden='true' /> Try again</button>
        </div>
      )}

      {!loading && !error && tasks.length === 0 && (
        <div className='atharo-hub__tasks-state atharo-hub__tasks-state--empty'>
          <MdCheckCircleOutline aria-hidden='true' />
          <strong>You&apos;re clear for today</strong>
          <span>No tasks are due today.</span>
        </div>
      )}

      {!loading && !error && tasks.length > 0 && (
        <section className='atharo-hub__today-task-list' aria-label="Today's tasks">
          {tasks.map((task) => {
            const subtasksLeft = getIncompleteSubtaskCount(task)
            const owner = String(task?.todoOwner || '').trim()
            const school = String(task?.whichSchool || '').trim()

            return (
              <button
                type='button'
                className='atharo-hub__today-task'
                key={task.todoId}
                onClick={() => onTaskClick(task)}
                aria-label={`Open task ${task.todoName}`}
              >
                <span className='atharo-hub__today-task-time'>
                  <BsClock aria-hidden='true' /> {formatDueTime(task.todoDueDate)}
                </span>
                <strong>{task.todoName}</strong>
                {task.todoDescription && <p>{task.todoDescription}</p>}
                <span className='atharo-hub__today-task-meta'>
                  {owner && <span><BsPerson aria-hidden='true' /> {owner}</span>}
                  {subtasksLeft > 0 && (
                    <span><BsListCheck aria-hidden='true' /> {subtasksLeft} left</span>
                  )}
                  {school && school.toLowerCase() !== 'all' && <span>{school.toUpperCase()}</span>}
                </span>
                <BsChevronRight className='atharo-hub__today-task-chevron' aria-hidden='true' />
              </button>
            )
          })}
        </section>
      )}
    </div>
  )
}

export default TodayTasks
